/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputEwZoneDirection
 */
export interface OutputEwZoneDirection {
    /**
     * 
     * @type {string}
     * @memberof OutputEwZoneDirection
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputEwZoneDirection
     */
    type?: string;
}

/**
 * Check if a given object implements the OutputEwZoneDirection interface.
 */
export function instanceOfOutputEwZoneDirection(value: object): boolean {
    return true;
}

export function OutputEwZoneDirectionFromJSON(json: any): OutputEwZoneDirection {
    return OutputEwZoneDirectionFromJSONTyped(json, false);
}

export function OutputEwZoneDirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputEwZoneDirection {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function OutputEwZoneDirectionToJSON(value?: OutputEwZoneDirection | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'type': value['type'],
    };
}

